import { render, staticRenderFns } from "./JeecgDemoList.vue?vue&type=template&id=4621ae2e&scoped=true"
import script from "./JeecgDemoList.vue?vue&type=script&lang=js"
export * from "./JeecgDemoList.vue?vue&type=script&lang=js"
import style0 from "./JeecgDemoList.vue?vue&type=style&index=0&id=4621ae2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4621ae2e",
  null
  
)

export default component.exports